import { z } from 'zod';

export const MAX_FIELDS_LENGTH = 20;

export const CONFIGURABLE_FIELDS = {
  SHORT_RESPONSE: 0,
  DATE_PICKER: 1,
  DROPDOWN_OPTIONS: 2,
  CHECKBOX_OPTIONS: 3,
  LONG_RESPONSE: 4,
  CONSENT_MESSAGE: 5,
} as const;
export type ReportFormFieldTypeName = keyof typeof CONFIGURABLE_FIELDS;
export const configurableFieldSchema = z.nativeEnum(CONFIGURABLE_FIELDS);
export type ReportFormFieldTypeId = z.infer<typeof configurableFieldSchema>;

export const CONDITIONAL_FIELDS = {
  SHORT_RESPONSE: 0,
  LONG_RESPONSE: 1,
  DROPDOWN_OPTIONS: 2,
} as const;

export type ConditionalFieldTypeName = keyof typeof CONDITIONAL_FIELDS;

export const FIXED_FIELDS = {
  FILE_UPLOAD: 7,
  REPORTER_NAME: 8,
  DESCRIPTION: 9,
  REPORT_TYPE: 10,
  COUNTRY: 11,
  MULTIPLE_ENTRY_TEXTFIELD: 6,
} as const;
export type FixedFieldTypeName = keyof typeof FIXED_FIELDS;
export const fixedFieldSchema = z.nativeEnum(FIXED_FIELDS);
export type FixedFieldTypeId = z.infer<typeof fixedFieldSchema>;

export const COMBINED_FIELDS = {
  ...FIXED_FIELDS,
  ...CONFIGURABLE_FIELDS,
} as const;

export const FIELD_KEYS: ReportFormFieldTypeName[] = Object.keys(
  CONFIGURABLE_FIELDS,
) as ReportFormFieldTypeName[];

export const FIELD_TYPE_LABELS: Record<ReportFormFieldTypeName, string> = {
  SHORT_RESPONSE: 'Short Response',
  LONG_RESPONSE: 'Long Response',
  CHECKBOX_OPTIONS: 'Checkbox',
  DROPDOWN_OPTIONS: 'Dropdown',
  CONSENT_MESSAGE: 'Consent Message',
  DATE_PICKER: 'Date Picker',
};

export const SUPPORTS_CONDITIONAL_LOGIC: Record<
  ReportFormFieldTypeName,
  boolean
> = {
  SHORT_RESPONSE: false,
  LONG_RESPONSE: false,
  CHECKBOX_OPTIONS: true,
  DROPDOWN_OPTIONS: true,
  CONSENT_MESSAGE: false,
  DATE_PICKER: false,
};

export const SUPPORTS_OPTIONS: Record<ReportFormFieldTypeName, boolean> = {
  SHORT_RESPONSE: false,
  LONG_RESPONSE: false,
  CHECKBOX_OPTIONS: true,
  DROPDOWN_OPTIONS: true,
  CONSENT_MESSAGE: false,
  DATE_PICKER: false,
};

export const combinedFieldSchema = z.nativeEnum(COMBINED_FIELDS);
export type CombinedFieldTypeName = keyof typeof COMBINED_FIELDS;
export type CombinedFieldsTypeId = z.infer<typeof combinedFieldSchema>;
